<app-admin-dashboard [blog_data]='blog_data' *ngIf="isLoggedIn" ></app-admin-dashboard>

